export enum TipoBloqueioHorario {
  Almoco = 0,
  Reuniao = 1,
  ConsultaExterna = 2,
  Treinamento = 3,
  Procedimento = 4,
  Intervalo = 5,
  Outro = 6,
}

export const TipoBloqueioHorarioLabels = {
  [TipoBloqueioHorario.Almoco]: 'Almoço',
  [TipoBloqueioHorario.Reuniao]: 'Reunião',
  [TipoBloqueioHorario.ConsultaExterna]: 'Consulta Externa',
  [TipoBloqueioHorario.Treinamento]: 'Treinamento',
  [TipoBloqueioHorario.Procedimento]: 'Procedimento',
  [TipoBloqueioHorario.Intervalo]: 'Intervalo',
  [TipoBloqueioHorario.Outro]: 'Outro',
};



